import request from '@/utils/request'
import {getUserInfo} from '@/utils/common'
import requestJxsDd from "@/utils/requestJxsDd";
import requestJxs from "@/utils/requestJxs";
import moment from "moment/moment";

// 获取老的全品类订单列表数据
export const getOldQplddList = (data) => {
    const userInfo = getUserInfo()
    return request('/frontend/qpldd/list.do', {
        params: {
            jxsbm: userInfo.jxsxx && userInfo.jxsxx.oldjxsbm,
            dlid: userInfo.sysid,
            ...data
        }
    })
}

// 获取老的全品类订单明细
export const getOldQplddDetail = (ddh) => {
    const userInfo = getUserInfo()
    return request('/frontend/qpldd/detailOld.do', {
        params: {
            czrmc: userInfo.zhmc,
            czrid: userInfo.sysid,
            ddh
        }
    })
}

// 获取全品类订单列表
export const getZmdJxslist = (data) => {
    const userInfo = getUserInfo()
    // 获取母公司信息
    return request('/backstage/jxsgl_qpldd/zmdJxslist.do', {
        params: {
            jxsbm: userInfo.jxsxx.partner,
            dlid: userInfo.sysid,
            ...data
        }
    })
}
// 获取全品类订单列表
export const getQplddList = (data) => {
    const userInfo = getUserInfo()
    // 获取母公司信息
    return request('/backstage/jxsgl_qpldd/weblist.do', {
        params: {
            jxsbm: userInfo.jxsxx.partner,
            dlid: userInfo.sysid,
            ...data
        }
    })
}

// 全品类订单获取订单详情
export const getOrderDetail = (ddh) => {
    const userInfo = getUserInfo()
    return request('/frontend/qpldd/detailZmd.do', {
        params: {
            ddh,
            czrmc: userInfo.zhmc,
            czrid: userInfo.sysid
        }
    })
}
// 手动工具
export const getOrderDetailSdgj = (ddh) => {
    const userInfo = getUserInfo()
    return request('/frontend/qpldd/detailSdgj.do', {
        params: {
            ddh,
            czrmc: userInfo.zhmc,
            czrid: userInfo.sysid
        }
    })
}

// 全品类订单获取凭证信息
export const getCredit = ({jxsbm, partner}) => {
    return request('/api/sap/query/credit.do', {
        params: {
            jxsbm,
            partner
        }
    })
}

// 全品类订单取消订单
export const cancelOrder = (id) => {
    const userInfo = getUserInfo()
    return request('/frontend/qpldd/cancelOrder.do', {
        method: 'post',
        data: {
            czrid: userInfo.sysid,
            czrmc: userInfo.zhmc,
            id,
            zt: "取消"
        }
    })
}

// 修改订单检查
export const modifyOrderCheck = (ddh) => {
    return request('/frontend/qpldd/modifyOrderCheck.do', {
        params: {
            ddh
        }
    })
}

// 全品类订单拆单
export const splitOrder = (data) => {
    return request('/backstage/jxsgl_qpldd/qplddzpcd.do', {
        method: 'post',
        data
    })
}

// 全品类订单--确认收货
export const confirmOrder = (id) => {
    const userInfo = getUserInfo()
    return request('/frontend/qpldd/confirmReceiptNew.do', {
        method: 'post',
        data: {
            czrid: userInfo.sysid,
            czrmc: userInfo.zhmc,
            id,
            zt: "确认收货",
        }
    })
}

// 导出订单明细
export const exportOrderDetail = (ddh) => {
    return request('/frontend/qpldd/exportOrder.do', {
        params: {
            ddh
        }
    })
}

// 全品类订单-通过取消
export const crossCancel = (id) => {
    const userInfo = getUserInfo()
    return request('/backstage/jxsgl_qpldd/adoptCancellation.do', {
        method: 'post',
        data: {
            czrid: userInfo.sysid,
            czrmc: userInfo.zhmc,
            id,
            zt: "确认",
        }
    })
}

// 全品类订单-不通过取消
export const disCrossCancel = (id) => {
    const userInfo = getUserInfo()
    return request('/backstage/jxsgl_qpldd/disAdoptCancellation.do', {
        method: 'post',
        data: {
            czrid: userInfo.sysid,
            czrmc: userInfo.zhmc,
            id,
            zt: "确认",
        }
    })
}

// 全品类订单-修改订单
export const modifyOrder = (params) => {
    const userInfo = getUserInfo()
    const data = {
        ...params,
        czrid: userInfo.sysid,
        czrmc: userInfo.zhmc,
        zt: "取消",
    }
    return request('/frontend/qpldd/modifyOrder.do', {
        method: 'post',
        data
    })
}

// 全品类订单-不通过修改
export const disCrossModify = (id) => {
    const userInfo = getUserInfo()
    return request('/backstage/jxsgl_qpldd/disAdoptUpdate.do', {
        method: 'post',
        data: {
            czrid: userInfo.sysid,
            czrmc: userInfo.zhmc,
            id,
            zt: "确认",
        }
    })
}

// 全品类订单 - 认领清除
export const clearClaim = (ids) => {
    return request('/backstage/jxsgl_qpldd/clearRlr.do', {
        method: 'post',
        data: {
            ids
        }
    })
}

// 全品类订单-认领
export const claim = (ids) => {
    const userInfo = getUserInfo()
    return request('/backstage/jxsgl_qpldd/setRlr.do', {
        method: 'post',
        data: {
            ids,
            czrmcs: [userInfo.zhmc],
            rlrghs: [userInfo.dcry && userInfo.dcry.rybm || '']
        }
    })
}

// 全品类订单 - sap同步
export const sapSync = (vbeln) => {
    return request('/api/sap/query/order.do', {
        params: {
            vbeln
        }
    })
}

// 全品类订单 - 一键释放
export const yjsf = (id) => {
    const userInfo = getUserInfo()
    return request('/backstage/jxsgl_qpldd/yjsf.do', {
        method: 'post',
        data: {
            id,
            czrid: userInfo.sysid,
            czrmc: userInfo.zhmc,
        }
    })
}
// 全品类订单 - 一键释放
export const yjsfDfdd = (id) => {
    const userInfo = getUserInfo()
    return request('/backstage/jxsgl_qpldd/yjsfDfdd.do', {
        method: 'post',
        data: {
            id,
            czrid: userInfo.sysid,
            czrmc: userInfo.zhmc,
        }
    })
}

// 添加订单
export const add = (data) => {

    return request('/frontend/qpldd/add.do', {
        method: 'post',
        data: {
            ...data
        },
        autopass: true
    })
}
// 添加订单
export const save = (data) => {
    const userInfo = getUserInfo()
    if(userInfo?.jxslx==="SDGJJXS") {
        return requestJxsDd('/jxs/JxsSdgjdd/saveGnxd', {
            method: 'post',
            data: {
                ...data
            },
            autopass: true,
            uncheck: true
        })
    }
    return requestJxsDd('/jxs/JxsQpldd/save', {
        method: 'post',
        data: {
            ...data
        },
        autopass: true,
        uncheck: true
    })
}
// 添加订单
export const saveSdgj = (data) => {
    const userInfo = getUserInfo()
    return requestJxsDd('/jxs/JxsSdgjdd/saveGnxd', {
        method: 'post',
        data: {
            ...data
        },
        autopass: true
    })
}
// 添加订单
export const auditOk = (data) => {
    return requestJxsDd('/jxs/JxsQpldd/auditOk', {
        method: 'post',
        data: {
            ...data
        },
        autopass: true
    })
}
// 添加订单
export const auditNo = (data) => {
    return requestJxsDd('/jxs/JxsQpldd/auditNo', {
        method: 'post',
        data: {
            ...data
        },
        autopass: true
    })
}
